import axios from "axios";
import Cookies from "js-cookie";
import apiUrl from "../utility/apiUrl";

const authHeaders = () => ({ Authorization: Cookies.get("token") });

export const getPreferences = () =>
  axios.get(`${apiUrl}/api/v1/student/preferences`, { headers: authHeaders() });

export const savePreferences = (preferences) =>
  axios.put(`${apiUrl}/api/v1/student/preferences`, preferences, { headers: authHeaders() });
